import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import {store} from './redux/store'
import * as serviceWorker from './serviceWorker';
import App from './App';
import { 
  BrowserRouter as Router, 
} from 'react-router-dom';
import './styles/pdf-viewer.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router history='browserHistory'>
	      <App/>
      </Router>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
